// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/KrutiDev_010.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: 'Kruti Dev 010';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.diff-container {
  font-family: 'Kruti Dev 010', monospace;
  white-space: pre-wrap;
  line-height: 1.5;
}

.diff-wrong {
  color: red;
  font-weight: bold;
}

.diff-correct {
  color: #555;
  margin-right: 2px;
}

.diff-missing {
  color: orange;
  font-style: italic;
  margin-right: 2px;
}

.diff-error {
  color: red;
}

.diff-error del {
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/components/DiffViewer.css"],"names":[],"mappings":";AACA;EACE,4BAA4B;EAC5B,+DAAkE;EAClE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["\n@font-face {\n  font-family: 'Kruti Dev 010';\n  src: url('../../public/fonts/KrutiDev_010.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n.diff-container {\n  font-family: 'Kruti Dev 010', monospace;\n  white-space: pre-wrap;\n  line-height: 1.5;\n}\n\n.diff-wrong {\n  color: red;\n  font-weight: bold;\n}\n\n.diff-correct {\n  color: #555;\n  margin-right: 2px;\n}\n\n.diff-missing {\n  color: orange;\n  font-style: italic;\n  margin-right: 2px;\n}\n\n.diff-error {\n  color: red;\n}\n\n.diff-error del {\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
